import { Asset } from '@/api/generatedApi';
import { HeaderText } from '@/components/HeaderText';
import { Box } from '@mui/material';
import { DependencyTreeContainer } from './DependencyTreeContainer';

export interface DependencyTreeDetailsProperties {
  asset?: Asset;
  onTreeItemClick?: (itemId: string) => void;
}

export const DependencyTreeDetails = ({ asset, onTreeItemClick }: DependencyTreeDetailsProperties) => {
  return asset?.hasDependencies ? (
    <Box color='text.primary'>
      <HeaderText margin={'4px 8px'}>Dependency Tree</HeaderText>

      <DependencyTreeContainer asset={asset} onTreeItemClick={onTreeItemClick} />
    </Box>
  ) : undefined;
};
